import React from "react";
import { User, LogOut, FileText, CheckCircle, Clock } from "lucide-react";
import EmployeeSidebar from "./EmployeeSidebar";
import Sidebar from "./Components/Sidebar/Sidebar";
import Sidebarapp2 from "./EmployeeSidebar";
import { useNavigate } from "react-router-dom";

const EmployeeDashboard = ({ user, onLogout }) => {
const navigate=useNavigate()
const onLogoutuser=()=>{
    localStorage.clear();
navigate("/")
}

  return (
    <div className="flex h-screen bg-gray-100">

      

      {/* Main Area */}
      <div className="flex-1 flex flex-col">

        {/* Topbar */}
        <header className="bg-white shadow flex justify-between items-center px-6 py-4">
          <h1 className="text-lg font-semibold">Employee Dashboard</h1>

          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <User size={18} />
              <span className="font-medium">
                {user?.name || "Employee"}
              </span>
            </div>

            <button
              onClick={onLogoutuser}
              className="flex items-center gap-2 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            >
              <LogOut size={16} /> Logout
            </button>
          </div>
        </header>

        {/* Content */}
        <main >
      <Sidebarapp2  />

        </main>
      </div>
    </div>
  );
};

export default EmployeeDashboard;